import money, { Money, format } from './money';

const notAString = val => typeof val !== 'string';
const notANumber = val => typeof val !== 'number';

export default (currency) => {
  const currentCurrency = currency.toUpperCase();
  const zero = Money.zero(currentCurrency);

  return (value) => {
    if (!value) return format(zero);

    if ((Money.isMoney(value) && value.isZero()) ||
      (notAString(value.amountCents) && notANumber(value.amountCents))) {
      return format(zero);
    }

    return format(money(value.amountCents, currency));
  };
};



// WEBPACK FOOTER //
// ./src/lib/currency-normalizer.js